/* eslint react/prop-types: warn */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import cx from "classnames";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
// TODO: These links will be fixed when the Runs redesign is done
import { Link as RouterLink } from "react-router-dom";

import { File, Gear, Magnify, Play } from "components/icons/generated";
import Icon from "ds/components/Icon";
import { withEnterKeyPress } from "utils/browser";
import { isModuleRunType } from "utils/run";

import { generateEntityLabel, translateEntity } from "./helpers";

const filtersKeys = [
  "commit",
  "commit.repository",
  "branch",
  "driftDetection",
  "labels",
  "type",
  "stack.id",
  "module.id",
  "state",
];

/**
 *
 * @deprecated Do nothing - waiting for the Runs redesign
 */
const ResourcesSideBarEntity = ({ entity, item, handleFilterNewChange }) => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const node = useRef(undefined);
  const dropdownClass = cx("resources-dropdown__menu", {
    "resources-dropdown__menu--visible": isDropdownVisible,
    "resources-dropdown__menu--top": item.key === "vendor",
  });
  const translatedValue = useMemo(
    () => translateEntity(item.entity, item.key),
    [item.entity, item.key]
  );
  const labelText = useMemo(
    () => generateEntityLabel(item.entity, item.key),
    [item.entity, item.key]
  );

  const isModuleRun = isModuleRunType(entity.type);
  const resourceLink = isModuleRun ? "module" : "stack";

  const handleClickOutside = useCallback(
    (e) => {
      if (node.current.contains(e.target)) {
        // inside click
        return;
      }
      // outside click
      setDropdownVisible(false);
    },
    [setDropdownVisible]
  );

  useEffect(() => {
    if (isDropdownVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownVisible, handleClickOutside]);

  const setFilter = useCallback(
    (e, key) => {
      e.preventDefault();
      const filterValue = translatedValue;
      const filterKey = key;

      handleFilterNewChange(filterKey, filterValue);
    },
    [handleFilterNewChange, translatedValue]
  );

  const handleCopy = useCallback(
    (e) => {
      e.preventDefault();
      if (window.isSecureContext) {
        navigator.clipboard.writeText(translatedValue);
      }
    },
    [translatedValue]
  );

  const handleClick = () => setDropdownVisible(!isDropdownVisible);

  return (
    <div className="resources-sidebar__entry">
      <label className="resources-sidebar__entry-label">{labelText}</label>
      <div
        className="resources-sidebar__entry-value"
        ref={node}
        onClick={handleClick}
        onKeyDown={withEnterKeyPress(handleClick)}
        role="button"
        tabIndex={0}
      >
        <div className="resources-sidebar__entry-wrapper">
          <Icon src={Gear} className="resources-sidebar__entry-icon" />
          <pre>
            <code>{translatedValue}</code>
          </pre>
        </div>
        {isDropdownVisible && (
          <ul className={dropdownClass}>
            {filtersKeys.includes(item.key) && (
              <li>
                <button
                  type="button"
                  className="resources-dropdown__button"
                  onClick={(e) => setFilter(e, item.key, item.entity)}
                >
                  <Icon src={Magnify} className="resources-dropdown__icon" />
                  Set as filter
                </button>
              </li>
            )}
            {item.key === "commit" && (
              <li>
                <a
                  className="resources-dropdown__button"
                  href={item.entity.url}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Icon src={Play} className="resources-dropdown__icon" />
                  Go to Commit
                </a>
              </li>
            )}
            {item.key === "id" && (
              <li>
                <RouterLink
                  className="resources-dropdown__button"
                  to={`/${resourceLink}/${
                    isModuleRun ? entity.module.id : entity.stack.id
                  }/run/${translatedValue}`}
                >
                  <Icon src={Play} className="resources-dropdown__icon" />
                  Go to Run
                </RouterLink>
              </li>
            )}
            {item.key === "stack" && (
              <>
                <li>
                  <RouterLink
                    className="resources-dropdown__button"
                    to={`/${resourceLink}/${translatedValue}`}
                  >
                    <Icon src={Play} className="resources-dropdown__icon" />
                    Go to Stack
                  </RouterLink>
                </li>

                <li>
                  <RouterLink
                    className="resources-dropdown__button"
                    to={`/stack/${translatedValue}/resources`}
                  >
                    <Icon src={Play} className="resources-dropdown__icon" />
                    Go to Stack Resources
                  </RouterLink>
                </li>
              </>
            )}
            {item.key === "module" && (
              <li>
                <RouterLink
                  className="resources-dropdown__button"
                  to={`/${resourceLink}/${translatedValue}`}
                >
                  <Icon src={Play} className="resources-dropdown__icon" />
                  Go to Module
                </RouterLink>
              </li>
            )}
            {item.key === "url" && (
              <li>
                <a
                  className="resources-dropdown__button"
                  href={translatedValue}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <Icon src={Play} className="resources-dropdown__icon" />
                  Go to URL
                </a>
              </li>
            )}
            <li>
              <button type="button" className="resources-dropdown__button" onClick={handleCopy}>
                <Icon src={File} className="resources-dropdown__icon" />
                Copy
              </button>
            </li>
          </ul>
        )}
      </div>
    </div>
  );
};

export default ResourcesSideBarEntity;
